/**
 * localStorage-backed display name persistence (FR-007).
 *
 * Safe against storage being unavailable (private mode, disabled cookies).
 */
const KEY = 'webrtc:displayName'

export function readDisplayName(): string {
  try {
    return localStorage.getItem(KEY) ?? ''
  } catch {
    return ''
  }
}

export function writeDisplayName(name: string): void {
  try {
    localStorage.setItem(KEY, name)
  } catch {
    // ignore — best effort
  }
}
